import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { subPlantHistoryReport } from '.';


export class SubPlantResponseModel extends GlobalResponseObject {
    data?: subPlantHistoryReport[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //subPlantHistoryReport
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: subPlantHistoryReport[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
